const SimpleLBox = function() {

    const constlightBx = function () {

        const parentGal = $('.gallery-zoom');

        parentGal.each(function(){
            if($(this).find('.ico-zoom').length > 0){
                new SimpleLightbox($(this).find('.ico-zoom'), { 
                    scrollZoom      : false,
                    captionSelector : 'self',
                    overlayOpacity  : 0.95,
                    loop            : false,
                    //showCounter : false
                });
            }
        })

    }

    return {
        init: function() {

            constlightBx();
        
        }
    }

}()

module.exports = SimpleLBox;